import type {Page, Result, UseCase} from 'framework';
import type {NutritionPlan} from '../../domain/nutrition-plan';
import type {NutritionPlanError} from '../../domain/errors';
import type {NutritionPlanRepository} from '../ports/nutrition-plan.repository';

export type ListNutritionPlansInput = {
  readonly cursor: string | null;
  readonly q: string;
};

export class ListNutritionPlans implements UseCase<[ListNutritionPlansInput], Page<NutritionPlan>> {
  constructor(private readonly repository: NutritionPlanRepository) {}

  execute(
    input: ListNutritionPlansInput,
  ): Promise<Result<Page<NutritionPlan>, NutritionPlanError>> {
    return this.repository.list(input);
  }
}
